<template>
  <v-app>
    <div class="app-horizontal-layout">
      <template v-if="!session_ready">
        <preloader></preloader>
      </template>

      <template v-else>
        <unknown-device :hash="hash"></unknown-device>
      </template>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Preloader from 'Components/Common/Preloader'
import UnknownDevice from 'Components/Auth/UnknownDevice'

export default {
  name: 'UnknownDeviceView',
  components: { Preloader, UnknownDevice },
  props: {
    hash: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['session_ready']),
  }
}
</script>

<style scoped>
  .app-horizontal-layout {
    height: 100vh;
  }
</style>
